const Cookie = {
  ACCESS_TOKEN: "accessToken",
  TOKEN_TYPE: "tokenType",
  USER_ID: "userId",
};

export default Cookie;
